<template>
  <div class="oauth-callback">
    <LoadingBounce></LoadingBounce>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import locales from '@/mixins/locales';
  import Mobile from '@/mixins/Mobile';

  export default {
    name: 'mobile-callback',

    mixins: [
      locales,
      Mobile,
    ],

    methods: {
      ...mapActions([
        'setToken',
        'setDevice',
        'signIn',
      ]),
    },

    computed: {
      ...mapGetters({
        routeQuery: 'getRouteQuery',
      }),
    },

    created() {
      const APP_NAME = 'classting';
      const continueUrl = this.routeQuery.continue_url;

      this.setDevice(APP_NAME);
      window.setToken = (token) => {
        this.setToken(token)
        .then(() => (
          this.signIn()
        ))
        .then((userInfo) => {
          this.$i18n.locale = this.getLocale(userInfo);
        })
        .then(() => {
          if (continueUrl) {
            this.$router.replace(window.decodeURIComponent(continueUrl));
          } else {
            this.$router.replace('/');
          }

          return Promise.resolve();
        });
      };

      this.call(`ctjscall://authorize?source=${APP_NAME}&callback=setToken`);
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/auth/views/MobileCallback.vue